import React, { Children } from 'react';
import PropTypes from 'prop-types';
import Link from '../Global/Link';
import Markdown from '../Richtext/Markdown';
import ImageHandler from '../../utils/ImageHandler';

// ====

const Spotlight = (props) => {
  const {
    label,
    title,
    description,
    link,
    backgroundImage,
    marginBottom,
  } = props;

  // ====

  return (
    <section
      className={`brand-section brand-section-wide brand-background-cover pt-3 pb-3 pt-md-5 pb-md-5 ${
        marginBottom && 'mb-4'
      }`}
      style={{
        backgroundImage: `linear-gradient(
          90deg,
          rgba(255, 255, 255, 0.9) 35%,
          rgba(255, 255, 255, 0.35) 100%
        ),
        url(${ImageHandler(backgroundImage, '1920x1080')})`,
      }}
    >
      <article className="container pt-3 pb-3 pt-md-5 pb-md-5">
        <div className="row justify-content-start">
          <div className="col-12 col-md-5 brand-col">
            <div className="card brand-background-transparent">
              {label && (
                <p className="m-0">
                  <span className="brand-label">{label}</span>
                </p>
              )}
              {title && <h3 className="brand-font-caps">{title}</h3>}
              {description && <Markdown>{description}</Markdown>}
            </div>
            {link && (
              <Link stretched button icon to={`/our-games/${link}/`}>
                Check it out
              </Link>
            )}
          </div>
        </div>
      </article>
    </section>
  );
};

export default Spotlight;

// ====

Spotlight.propTypes = {
  marginBottom: PropTypes.bool,
  label: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  link: PropTypes.string,
  backgroundImage: PropTypes.string,
};

Spotlight.defaultProps = {
  marginBottom: false,
  label: '',
  title: '',
  description: '',
  link: '',
  backgroundImage: '',
};
